module.exports = __webpack_public_path__ + "img/text-lastschrift.6a31f75b.png";